/**
 * Returns the most recent refresh timestamp from a list of feed
 * `lastRefreshed` values, or null when no feeds have been refreshed.
 */
export function mostRecentRefresh(timestamps: string[]): string | null {
  if (timestamps.length === 0) {
    return null
  }

  return timestamps.reduce((latest, timestamp) =>
    new Date(timestamp) > new Date(latest) ? timestamp : latest,
  )
}
